<template>
  <div class="cart-header-container pt-7 pb-4 px-4">
    <div v-if="isCulturePassEnable" class="cart-back-button d-flex flew-row align-center">
      <BackButton
        customBack
        class="back"
        @back="goBack"
      />
      <h1
        class="text-h3 ml-5"
      >
        Previous Page
      </h1>
    </div>
  </div>
</template>

<script lang="ts"> 
import Vue from 'vue'
import Options from 'vue-class-component'

import BackButton from '@/components/BackButton.vue'
import { getPath } from '@/utils/general-utils'
import { mapGetters } from 'vuex'

@Options({
  components: {
    BackButton,
  },
  computed: {
    ...mapGetters([
      'isCulturePassEnable',
      'previousProductUrl',
    ])
  }
})
export default class CartHeader extends Vue {
  isCulturePassEnable!: boolean
  previousProductUrl!: string

  goBack(): void {
    if (this.isCulturePassEnable && this.previousProductUrl) {
      this.$router.push(this.previousProductUrl)
    } else {
      this.$router.push(getPath('/'))
    }
  }
}
</script>

<style lang="scss" scoped>

@media #{map-get($display-breakpoints, "sm-and-up")} {
  .cart-container {
    .cart-back-button{
      margin: 0;
    }
  }
}

@media #{map-get($display-breakpoints, "md-and-up")} {
  .cart-container {
    max-width: 50%;
    .cart-back-button{
      align-items: center;
    }
  }
}

@media #{map-get($display-breakpoints, "lg-and-up")} {
  .cart-container {
    max-width: 35%;
  }
}

</style>